import React, { useEffect, useRef } from "react";
import {
  Avatar,
  Button,
  Container,
  CssBaseline,
  Typography,
} from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { LockOutlined } from "@material-ui/icons";
import { Link, Redirect } from "react-router-dom";
import {
  consumeRecoveryCodeRecommendation,
} from "./loginSlice";
import { useAppDispatch, useTypedSelector } from "../../app/store";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      marginTop: theme.spacing(8),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    content: {
      width: "100%",
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
  })
);

export function RecoveryCodeRecommendationPage() {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const state = useTypedSelector((x) => x.login);
  const canDisplay = useRef(
    state.loggedIn && state.loggedInWithRecoveryCode
  ).current;

  useEffect(() => {
    if (canDisplay) {
      dispatch(consumeRecoveryCodeRecommendation());
    }
  }, [canDisplay, dispatch]);

  if (!state.loggedIn) {
    return <Redirect to="/login" />;
  }
  if (!canDisplay) {
    return <Redirect to="/contract" />;
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlined />
        </Avatar>
        <Typography component="h1" variant="h5">
          二要素認証再設定のご案内
        </Typography>
        <div className={classes.content}>
          <Typography component="p" variant="body1">
            リカバリーコードでログインしました。
            <br />
            以前とは別の端末で認証アプリを利用したい場合は、二要素認証を再設定することができます。
          </Typography>
          <Button
            className={classes.submit}
            color="primary"
            variant="contained"
            component={Link}
            to="/security"
            fullWidth
          >
            二要素認証の設定ページに移動する
          </Button>
        </div>
      </div>
    </Container>
  );
}
